<template>
  <div style="display: flex;align-items: center">
    <el-tooltip v-if="Boolean(content)" :content="content" placement="right-end">
      <i class="el-icon-warning red" />
    </el-tooltip>
    <div style="flex: 1;">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecialCharacterTip',
  props: {
    texts: { type: Array, default: null }
  },
  computed: {
    content() {
      if (this.texts && this.texts.length > 0) {
        return this.$t('CargoMsg.SpecialCharactersExcept') + '：' + Array.from(this.texts, p => `"${p}"`).join('，')
      }
      return ''
    }
  }
}
</script>
